<template>
  <div>
    <DxForm
      :form-data="formData"
      :items="visibleItems"
      :label-location="labelLocation"
      @fieldDataChanged="handleFieldChange"
    >
      <!-- New custom checkbox -->
      <template #form-new-checkbox-group="{ data: item }">
        <NewCheckBoxGroup
          v-model="formData[item.dataField]"
          :checkList="item"
          @update:modelValue="handleCheckboxChange(item.dataField, $event)"
        >
        </NewCheckBoxGroup>
      </template>

     

      <!-- Dependent Select Box -->
      <template #form-dependent-select-box="{ data: item }">
        <DependentSelectBoxCompo
          :item="item"

          @update:value="handleSelectionChange"
        />
      </template>

      <!-- Custom Fields -->
      <template #cstm_field="{ data: item }">
        <div>
          <custom-field-types
            :item="item"
            :prefix="slug"
            :routeDef="routeDef"
            :defaultDate="defaultDate"
            v-model="formData[item.dataField]"
            @onTransactionDateChanged="handleTransactionDate"
            @onRelateValueChanged="updateCheckboxValue"
            @update:value="onBaseModuleChange"
          >
          </custom-field-types>
        </div>
      </template>
    </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";
import NewCheckBoxGroup from "@/components/NewCstmCheckBoxGroup.vue";
import CustomFieldTypes from "@/components/CustomFieldTypes.vue";
import DependentSelectBoxCompo from "../components/DependentSelectBoxCompo.vue";

export default {
  props: {
    createDef: Array,
    selectedDropdownOption: Array,
    routeDef: String,
    defaultDate: Boolean,
    dependentOptions: Array,
    slug: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    viewType: String,
  },
  components: {
    DxForm,
    NewCheckBoxGroup,
    DxSelectBox,
    CustomFieldTypes,
    DependentSelectBoxCompo
  },
  data: function () {
    return {
      selectedList: null,
      selectedListOptions: [],
      selectedDefaultlist: null,
      DD_List: [],
      labelLocation: "top",
      watchList: [],
      lineItemFieldList: [],
      log: console.log,
      items: this.createDef,
      fields: ["name", "address"],
      selectedCheckboxes: [],
      visibleItems: [],
      hiddenFields: [],
      formData: { ...this.modelData },
      // Store the dependent select box values
      dependentSelectValues: {
        dropdownList: null,
        defaultList: null,
      },
      baseModuleValue: {
        baseModuleId: null,
        baseModuleName: null,
      },
      currentField: null,
      relateFieldValues: {},
      fieldListner: [
        {
          field: "Test1_LineItem:address",
          relateFields: ["name", "Test1_LineItem:name"],
        },
        {
          field: "test1",
          relateFields: ["name"],
        },
        {
          field: "Test1_LineItem:address",
          relateFields: ["name"],
        },
      ],
    };
  },
  methods: {
    /* Base Module */
    handleRelateItemSelected(item) {
      this.relateFieldValues[item.fieldName] = {
        id: item.id,
        name: item.name,
      };
    },
   
    

    /* Base Module */
    onBaseModuleChange(newValue) {
      this.baseModuleValue = newValue;
      this.formData.base_module_id = newValue.id;
      this.formData.base_module_name = newValue.name;
    },
    // Capture and store the selection from DependentSelectBoxCompo
    handleSelectionChange(newValues) {
      this.dependentSelectValues = newValues;

      // Store these values in formData so they'll be included on submit
      this.formData.dropdownListSelection = newValues.dropdownList;
      this.formData.defaultListSelection = newValues.defaultList;
    },

    // Method to get form data including dependent select box values
    getFormData() {
      // Return the combined form data
      return {
        ...this.formData,
        dropdownListSelection: this.dependentSelectValues.dropdownList,
        defaultListSelection: this.dependentSelectValues.defaultList,
        baseModuleName: this.baseModuleValue.name,
        baseModuleId: this.baseModuleValue.id,
      };
    },

    handleCheckboxChange(field, newValue) {
      // this.getDDList();
      this.formData[field] = newValue;

      if (newValue === true) {
        this.visibleItems = this.items;
        this.disabledItems(this.visibleItems, true);
      } else {
        this.visibleItems = this.hiddenFields;
        this.disabledItems(this.visibleItems, false);
      }
    },

    filterVisibleItems() {
      // Deep clone the original form items to avoid direct mutation
      const items = JSON.parse(JSON.stringify(this.items));

      // Recursively filter out hidden groups and items
      const filterHiddenItems = (itemArray) => {
        return itemArray.filter((item) => {
          // If the item is a group, filter its nested items
          if (item.itemType === "group") {
            if (item.hidden === true) {
              return false; // Completely remove hidden groups
            }

            // Filter nested items within the group
            if (item.items) {
              item.items = filterHiddenItems(item.items);
            }
          }

          // Keep non-hidden items
          return item.hidden !== true;
        });
      };

      this.hiddenFields = filterHiddenItems(items);
      // Apply the filtering
      this.visibleItems = filterHiddenItems(items);
    },

    /* Find disabled field method */
    disabledItems(items, disabled) {
      items.forEach((item) => {
        if (item.editorOptions) {
          item.editorOptions.disabled = disabled;
        }

        // Recursively handle groups
        if (item.itemType === "group" && Array.isArray(item.items)) {
          this.disabledItems(item.items, disabled);
        }
      });
      // const setEditorDisabled = (items, disabled) => {
      //   items.forEach(item => {
      //     if (item.editorOptions) {
      //       item.editorOptions.disabled = disabled;
      //     }

      //     // Recursively handle groups
      //     if (item.itemType === 'group' && Array.isArray(item.items)) {
      //       setEditorDisabled(item.items, disabled);
      //     }
      //   });
      // };
    },
  },
  mounted() {
    this.filterVisibleItems();
    // Other mounted code...
  },
  created() {
    this.filterVisibleItems();
  },
};
</script>

<style>
.dx-form .dx-field-item-label {
  font-size: 12px;
  margin-bottom: 0px;
}

.createName {
  background-color: white !important;
  margin-top: 10px;
  padding: 10px 30px;
}

.dx-form-group-caption {
  font-size: 14px;
  font-weight: bold;
  color: #535252;
}
</style>